export function dispatchStorageEvent(key: any, newValue: any) {
  return window.dispatchEvent(new StorageEvent('storage', { key, newValue }))
}
